export enum EState {
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PENDING = 'pending',
  NEW = 'new',
}
